










import SearchIcon from '@/components/common/UniversalSearch/images/search.vue.svg';

export default {
  name: 'UniversalSearchPlaceholder',
  components: {
    SearchIcon,
  },
};
